function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.562 17c-.38 0-.688.448-.688 1 0 .51.263.93.602.992l.086.008H22.31c.38 0 .687-.448.687-1 0-.51-.262-.93-.601-.992L22.311 17H8.56zm-6.875-6c-.38 0-.687.448-.687 1 0 .51.262.93.601.992l.086.008h20.624c.38 0 .687-.448.687-1 0-.51-.262-.93-.601-.992L22.311 11H1.687zm0-6C1.308 5 1 5.448 1 6c0 .51.262.93.601.992L1.687 7h20.624c.38 0 .687-.448.687-1 0-.51-.262-.93-.601-.992L22.311 5H1.687z"
});

var SvgIcMenu = function SvgIcMenu(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcMenu, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_menu.1099189c.svg";
export { ForwardRef as ReactComponent };